import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { enqueueSnackbar } from "notistack";

export default function MapController({ bounds, polygonData, type }) {
  const map = useMap();

  // useEffect(() => {
  //   let newBounds;

  //   if (type === "geojson" && polygonData) {
  //     // Handle different types of GeoJSON geometries
  //     try {
  //       let coordinates = [];

  //       if (polygonData.type === "Polygon") {
  //         coordinates = polygonData.coordinates[0];
  //       } else if (polygonData.type === "MultiPolygon") {
  //         coordinates = polygonData.coordinates.flat(1);
  //       } else if (Array.isArray(polygonData.coordinates)) {
  //         coordinates = polygonData.coordinates;
  //       }

  //       const validCoords = coordinates
  //         .filter((coord) => Array.isArray(coord) && coord.length >= 2)
  //         .map((coord) => [coord[1], coord[0]]);

  //       if (validCoords.length > 0) {
  //         newBounds = L.latLngBounds(validCoords);
  //       }
  //     } catch (error) {
  //       console.warn("Error processing GeoJSON data:", error);
  //     }
  //   } else if (type === "polygonData" && polygonData?.length > 0) {
  //     try {
  //       const coordinates = polygonData.flatMap((item) =>
  //         item.coordinates.map((coord) => [
  //           parseFloat(coord.latitude),
  //           parseFloat(coord.longitude),
  //         ])
  //       );
  //       if (coordinates.length > 0) {
  //         newBounds = L.latLngBounds(coordinates);
  //       }
  //     } catch (error) {
  //       console.warn("Error processing polygon data:", error);
  //     }
  //   } else if (type === "user" && polygonData?.length > 0) {
  //     try {
  //       const coordinates = polygonData.map((coord) => [
  //         parseFloat(coord.latitude),
  //         parseFloat(coord.longitude),
  //       ]);
  //       if (coordinates.length > 0) {
  //         newBounds = L.latLngBounds(coordinates);
  //       }
  //     } catch (error) {
  //       console.warn("Error processing user location data:", error);
  //     }
  //   }

  //   if (newBounds && newBounds.isValid()) {
  //     map.fitBounds(newBounds, {
  //       padding: [0, 0],
  //       maxZoom: 22,
  //     });
  //   }
  // }, [map, polygonData, type]);

  useEffect(() => {

    if (bounds && bounds.isValid()) {
      map.fitBounds(bounds, {
        padding: [0, 0],
        maxZoom: 22,
      });
    } else {
      enqueueSnackbar("Invalid map bounds", {
        variant: "warning",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  }, [map, bounds]);
  return null;
}
